<template>
  <div class="wrap" style="padding-top: 1rem">
    <!--<navTitle title="存款" color="#FA6704" font="#fff"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Deposit'
      "
      color="#FA6704"
      font="#fff"
    ></navTitle>

    <div class="card">
      <div class="tips" @click="$router.push({ path: '/user/bank/log' })">
        Details of funds
      </div>
      <div class="hr"></div>
      <div class="info">Total Amount</div>
      <p class="save_money">{{ info.money }}</p>
      <div class="info-bottom">
        Yesterday's earnings<span class="font-color-red"> {{icon_moeny}}{{ info.yesterday_interest }}</span
        >
      </div>
      <div class="hr"></div>
      <div class="info-tab">
        <div class="info-item">
          <div class="title">Accumulated interest</div>
          <div class="price">{{ info.total_interest }}</div>
        </div>
        <div class="info-item">
          <div class="title">Annualized deposits</div>
          <div class="price">{{ info.deposit_annual }}</div>
        </div>
      </div>
      <div class="btn-tab">
        <div
          @click="
            $router.push({ path: '/user/bank/recharge', query: { type: 0 } })
          "
          class="btn out"
        >
          Transfer out
        </div>

        <div
          @click="
            $router.push({ path: '/user/bank/recharge', query: { type: 1 } })
          "
          class="btn in"
        >
          Transfer in
        </div>
      </div>
    </div>
    <div class="list"></div>
  </div>
</template>

<script>
import navTitle from "@components/navTitle";
import { deposit_info, deposit_log } from "@api/user";
export default {
  name: "bank",
  components: {
    navTitle
  },
  data: function() {
    return {
      icon_moeny:this.global.moeny,
      
      userInfo: "",
      info: ""
    };
  },
  watch: {
    $route(n) {
      if (n.name === "bank") {
        this.getList();
      }
    }
  },
  methods: {
    getList() {
      deposit_info(this.id).then(res => {
        // console.log('deposit_info:',res)
        this.info = res.data;
      });
      deposit_log({ page: 1, limit: 20 }).then(res => {
        this.list = res.data;
      });
    }
  },
  mounted: function() {
    this.getList();
  }
};
</script>

<style scoped>
.wrap {
  width: 100%;

  padding: 0.3rem;
  box-sizing: border-box;
  background: -webkit-gradient(
    linear,
    30 30,
    20 100%,
    from(#fa6704),
    to(#f5f5f5)
  );
}

.card {
  width: 100%;
  padding: 0.3rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.05rem;
  margin-top: 0.3rem;
  text-align: center;
  box-shadow: 0 0 10px #ddd;
  position: relative;
}
.hr {
  width: 100%;
  height: 0.5rem;
}
.info {
  width: 100%;

  height: 0.5rem;
  line-height: 0.5rem;
  color: #333;
  font-size: 0.26rem;
}
.info-bottom {
  margin: 0 auto;
  width: auto;
  display: inline-block;
  padding: 0rem 0.3rem;
  height: 0.5rem;
  line-height: 0.5rem;
  color: #666;
  font-size: 0.28rem;
  border-radius: 0.15rem;
  background: #f7f8f9;
}
.info-bottom > span {
  margin: 0 4px;
  font-size: 0.32rem;
}

.save_money {
  width: 100%;
  line-height: 0.6rem;
  height: 0.9rem;
  font-size: 0.6rem;
}
.info-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.info-item {
  flex: 1;
}
.info-item .title {
  color: #999;
  font-size: 0.28rem;
}
.info-item .price {
  color: #333;
  font-size: 0.32rem;
  font-weight: bold;
}
.btn-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
}

.btn-tab .btn {
  width: 48%;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.33rem;
}
.out {
  background: #fcf6ee;
  color: #fa6704;
}
.in {
  background: #fa6704;
  color: #fcf6ee;
}
.tips {
  position: absolute;
  right: 0px;
  top: 10px;
  padding: 0.06rem 0.3rem 0.06rem 0.3rem;
  box-sizing: border-box;
  background: #999;
  color: #fff;
  text-align: center;
  border-radius: 0.3rem 0 0 0.3rem;
}
.list {
  width: 100%;
  padding: 0.3rem;
  box-shadow: black;
}
</style>
